import { useLocation, useNavigate } from 'react-router-dom';
import {LayoutContent} from './useLayout'
import styled from 'styled-components'
import Header from '../../components/Header';
import Tabbar from '../../components/Tabbar';
import {headerPath,tabbarPath} from '../../utils/constants'
import ForwardTo from '../../components/ForwardTo';
import { useIntl } from 'react-intl';
import { Modal } from 'antd-mobile';
import { useEffect } from 'react';
export default function LayoutProvider(
  {children}
) {
  
  const href = useLocation();
  const navigate = useNavigate()
  const intl = useIntl()
  const navigateTo = (next) => {
    let urls = window.localStorage.getItem("RUNBUT_PATHS")
    if(urls) {
      urls = JSON.parse(urls)
    }else {
      urls = []
    }

    urls.push({
      url:  window.location.pathname
    })
    urls = JSON.stringify(urls)
    window.localStorage.setItem('RUNBUT_PATHS',urls)
    navigate(
      next,
      {
        state:{
          url:window.location.pathname
        }
      }
    )
  
  }


  // useEffect(() => {
  //   showForwardTo()
  // },[])
  const  showForwardTo = () => {
    const m = Modal.show({
      title: intl.formatMessage({
        id: "pages.account.profit_harvest_title",
        defaultMessage: "通知",
      }),
      bodyClassName: "runbit_modal one_btn",
      // showCloseButton: true,
      actions: [
        {
          key: "confrim",
          className: "primary_btn",
          text:  intl.formatMessage({
            id: "common.to_home",
            defaultMessage: "去首页",
          }),
          primary: true,
        },
      ],
      onAction: async (action, index) => {
        window.location.href = 'https://runbit.io'
      },
      closeOnAction: false,
      content: (
        <ForwardTo
          intl={intl}
        />
      ),
    });
    console.log('m',m)
  }

  return <LayoutContent.Provider value={{
    navigateTo
  }}>
   
     {headerPath.includes(href.pathname) ||
     tabbarPath.includes(href.pathname) ? (
       <Container>
         {headerPath.includes(href.pathname) ? <Header /> : null}
         {children}
         {tabbarPath.includes(href.pathname) ? <Tabbar /> : null}
       </Container>
     ) : (
       children
     )}

  </LayoutContent.Provider>
}
const Container = styled.div`
  padding: .5rem .7rem 0;
`;
